var map = {
	"./404.vue": "+H76",
	"./HelloWorld.vue": "q/3a",
	"./admin/appGames.vue": "2ioW",
	"./admin/appProducts.vue": "eTWI",
	"./admin/apps.vue": "0a0v",
	"./admin/games.vue": "KZi9",
	"./admin/home.vue": "3Mvt",
	"./admin/orders.vue": "NvuA",
	"./admin/password.vue": "s8Rm",
	"./admin/products.vue": "zKk6",
	"./admin/statistics/activeUser.vue": "0lyi",
	"./admin/statistics/arppu.vue": "BEk4",
	"./admin/statistics/arpu.vue": "iJs3",
	"./admin/statistics/diamond.vue": "iadH",
	"./admin/statistics/expenseUser.vue": "kcxJ",
	"./admin/statistics/newUser.vue": "zWR8",
	"./admin/statistics/payUser.vue": "BbwP",
	"./admin/statistics/totalConsumeDiamond.vue": "wmzQ",
	"./layout/Layout.vue": "AkUR",
	"./layout/components/AppMain.vue": "BoPo",
	"./layout/components/Navbar.vue": "6k2e",
	"./layout/components/Sidebar/SidebarItem.vue": "tlvQ",
	"./layout/components/Sidebar/index.vue": "WTox",
	"./login/changePassword.vue": "qOZg",
	"./login/index.vue": "T+/8",
	"./login/login.vue": "W2Q3",
	"./login/register.vue": "12H5",
	"./web/home.vue": "oUp+",
	"./web/wechat/callback.vue": "6Rn7",
	"./web/wechat/product.vue": "5ybC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EtAD";


//////////////////
// WEBPACK FOOTER
// ./src/views ^\.\/.*\.vue$
// module id = EtAD
// module chunks = 3